import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridCustomPagination } from "components/helpers";
import { columns } from "./helper";

const DictationSummaryGrid = ({
  data = [],
  loading = false,
  selectedRowIds = [],
  setSelectedRowIds,
  practiceUsers = [],
  isDialog = false,
  updateSelectedDictations,
  updateErrorFields,
  updateAssignedUser,
}) => {
  const isIgnoredRow = (row) => {
    return (
      row.adv_chart_status === "N/A" &&
      row.scribing_status === "N/A" &&
      row.coding_status === "N/A" &&
      row.resource_id_adv_chart === "NA" &&
      row.resource_id_scribing === "NA" &&
      row.resource_id_coding === "NA"
    );
  };

  return (
    <DataGrid
      rows={data}
      columns={columns(
        updateSelectedDictations,
        updateSelectedDictations,
        updateErrorFields,
        updateAssignedUser,
        practiceUsers,
        isDialog,
      )}
      checkboxSelection
      rowSelectionModel={selectedRowIds}
      onRowSelectionModelChange={(ids) => {
        setSelectedRowIds(ids);
      }}
      getRowClassName={(params) => {
        const classNames = [];

        if (params.row.error_exists === "Yes") classNames.push("error-row-yes");
        if (params.row.error_exists === "No") classNames.push("error-row-no");
        if (isIgnoredRow(params.row)) classNames.push("ignored-row");

        return classNames.join(" ");
      }}
      sx={{
        height: "75vh", // important for sticky header + scroll
        backgroundColor: "#fff",

        "& .error-row-yes": {
          backgroundColor: "#ffebee",
        },

        "& .error-row-no": {
          backgroundColor: "#e8f5e9",
        },

        // strike-through ignored rows except checkbox
        "& .ignored-row .MuiDataGrid-cell:not(.MuiDataGrid-cellCheckbox)": {
          textDecoration: "line-through",
          opacity: 0.65,
        },

        "& .ignored-row .MuiDataGrid-cellCheckbox": {
          opacity: 1,
        },

        "& .MuiDataGrid-cell": {
          display: "flex",
          alignItems: "center",
        },

        //Freeze top header row like Excel
        "& .MuiDataGrid-columnHeaders": {
          position: "sticky",
          top: 0,
          backgroundColor: "#fafafa",
          zIndex: 1000,
          borderBottom: "1px solid #ddd",
        },

        // optional better header style
        "& .MuiDataGrid-columnHeader": {
          fontWeight: 600,
          backgroundColor: "#fafafa",
        },
      }}
      getRowId={(row) => row.patient_id}
      loading={loading}
      pageSizeOptions={isDialog ? [15, 30, 45] : [25, 50, 100]}
      initialState={{
        sorting: {
          sortModel: [{ field: "dos", sort: "asc" }],
        },
        pagination: {
          paginationModel: {
            pageSize: isDialog ? 15 : 50,
          },
        },
      }}
      slots={{
        pagination: DataGridCustomPagination,
        toolbar: GridToolbar,
      }}
      slotProps={{
        loadingOverlay: {
          variant: "linear-progress",
          noRowsVariant: "linear-progress",
        },
      }}
      getRowHeight={() => "auto"}
    />
  );
};

export default DictationSummaryGrid;
